/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Delete_Loading_TitleInputs */

const es_feedback_delete_loading_title = /** @type {(inputs: Feedback_Delete_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando feedback...`)
};

const en_feedback_delete_loading_title = /** @type {(inputs: Feedback_Delete_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting feedback...`)
};

/**
* | output |
* | --- |
* | "Deleting feedback..." |
*
* @param {Feedback_Delete_Loading_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_delete_loading_title = /** @type {((inputs?: Feedback_Delete_Loading_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Delete_Loading_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_delete_loading_title(inputs)
	return en_feedback_delete_loading_title(inputs)
});
export { feedback_delete_loading_title as "feedback.delete.loading_title" }